import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as callFlowAPI from 'api/Settings/callFlow';
import { TYPE_OF_FIELD_IN_COLUMN } from 'utils/scorecard';

const initalState = {
  pageSize: 10,
  currentPage: 1,
  LOB: null,
  LOB2: null,
  LOBTeam: null,
  LOBTeam2: null,
  LOBTeamAgent: null,
  LOBTeamAgent2: null,
  selected: {
    LOB: [],
    LOBTeam: [],
    LOBTeamAgent: [],
    fields: {},
    rowFilter: {
      LOB: false,
      LOBTeam: false,
      LOBTeamAgent: false
    }
  },
  ui: {
    LOB: {
      status: '',
      loading: false,
      flag: false
    },
    LOBTeam: {
      status: '',
      loading: false,
      flag: false
    },
    LOBTeamAgent: {
      status: '',
      loading: false
    },
    loading: false
  },
  callCount: {
    data: null,
    totalRecords: 0,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      { title: 'Date', key: 'date', type: TYPE_OF_FIELD_IN_COLUMN.DATE, width: 210 },
      { title: 'Total Calls', key: 'total_raw_calls', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Processing', key: 'processing', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Processed', key: 'processed', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Insuff_trans', key: 'insuff_trans', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Failed', key: 'failed', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Completed', key: 'completed', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 }
      // { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init',
    selectedCallDate: null,
    selectedCallType: null
  },
  callStatus: {
    data: null,
    totalRecords: 0,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      { title: 'Call Id', key: 'call_id', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Call Name', key: 'call_name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 210 },
      { title: 'Call URL', key: 'call_url', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Status', key: 'status', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 },
      { title: 'Re-run', key: 're_run', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init',
    selectedCallId: null,
    errorData: null,
    callFlowModalValue: [],
    modalData: null
  }
};
const getCallCountData = createAsyncThunk('settings/callflow/getCallCountData', async (filter) => {
  const res = await callFlowAPI.getCallCountData(filter);
  return res.data?.data;
});

const getCallStatusData = createAsyncThunk('settings/callflow/getCallStatusData', async (filter) => {
  const res = await callFlowAPI.getCallStatusData(filter);
  return res.data?.data;
});

const getErrorCallMessageData = createAsyncThunk('settings/callflow/getErrorCallMessageData', async (filter) => {
  const res = await callFlowAPI.getErrorCallMessageData(filter);
  return res.data?.data;
});

const reRunCall = createAsyncThunk('settings/callflow/reRunCall', async (filter) => {
  const res = await callFlowAPI.reRun(filter);
  return res?.data;
});

const resumeCall = createAsyncThunk('settings/callflow/resumeCall', async (filter) => {
  const res = await callFlowAPI.resume(filter);
  return res?.data;
});

const reRunFeatures = createAsyncThunk('settings/callflow/reRunFeatures', async (filter) => {
  const res = await callFlowAPI.reRunFeature(filter);
  return res?.data;
});

const getLobData = createAsyncThunk('settings/callflow/readLob', async () => {
  const res = await callFlowAPI.getLobData();
  return res.data?.data;
});
const getteamData = createAsyncThunk('settings/callflow/readTeam', async () => {
  const res = await callFlowAPI.getTeamsData();
  return res.data?.data;
});
const getagentData = createAsyncThunk('settings/callflow/readAgent', async () => {
  const res = await callFlowAPI.getUsersData();
  return res.data?.data;
});
const ModalDataSubmit = createAsyncThunk('settings/callflow/submitModaldata', async (params) => {
  try {
    const res = await callFlowAPI.modalDataSubmit(params);
    return res.data?.data;
  } catch (error) {
    console.error('ModalDataSubmit', error);
  }
});
const CallFlow = createSlice({
  name: 'callFlow',
  initialState: initalState,

  reducers: {
    resetState: () => {
      return initalState;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setSelectedCallDate: (state, action) => {
      state.callCount.selectedCallDate = action?.payload;
    },
    setSelectedCallType: (state, action) => {
      state.callCount.selectedCallType = action?.payload;
    },
    setSelectedCallId: (state, action) => {
      state.callStatus.selectedCallId = action?.payload;
    },
    setCallStatusData: (state, action) => {
      const data = action.payload;
      if (data) {
        const callStatusData = state.callStatus.data;
        const Idx = callStatusData?.findIndex((item) => item.call_id === Object.keys(data)[0]);
        if (Idx !== -1) {
          state.callStatus.data[Idx] = { ...callStatusData[Idx], ...Object.values(data)[0] };
        }
      }
    },
    setCallCountData: (state, action) => {
      const data = action.payload;
      if (data) {
        const callCountData = state.callCount.data;
        const Idx = callCountData?.findIndex((item) => item.date === Object.keys(data)[0]);
        if (Idx !== -1) {
          state.callCount.data[Idx] = { ...callCountData[Idx], ...Object.values(data)[0] };
        }
      }
    },
    // setValueModal: (state, action) => {
    //   const previousCallFlowModalValue = Array.isArray(state.callFlowModalValue) ? [...state.callFlowModalValue] : [];
    //   const serializedPayload = { ...action.payload, recording_file: action.payload.recording_file || [] };
    //   console.log('setValueModal', action.payload.recording_file[0]);
    //   state.callFlowModalValue = [...previousCallFlowModalValue, serializedPayload];
    // },
    setValueModal: (state, action) => {
      const previousCallFlowModalValue = Array.isArray(state.callFlowModalValue) ? [...state.callFlowModalValue] : [];
      // const recordingFileNames = action.payload.recording_file;
      const serializedPayload = { ...action.payload };
      state.callFlowModalValue = [...previousCallFlowModalValue, serializedPayload];
    },
    RemoveValueModal: (state, action) => {
      console.log(state, action);
      const filtervalue = state.callFlowModalValue.filter((_, index) => index !== action.payload);
      state.callFlowModalValue = filtervalue;
    },
    handleLobFilterChange: (state, action) => {
      // console.error(current(state));
      console.log('actionCallflow', action.payload);
      const findIndex = state.LOB.findIndex((item) => item.id === action.payload.id);
      if (!state.selected.LOB.includes(state.LOB[findIndex])) {
        state.selected.LOB[findIndex] = state.LOB[findIndex];
      }
      state.LOB.map((item) => {
        if (item) item.status = false;
      });
      state.selected.LOB.map((item) => {
        if (item) item.status = false;
      });
      state.selected.LOB[findIndex].status = action.payload.status;
      console.log('findIndexLOB', findIndex);
    },
    handleTeamFilterChange: (state, action) => {
      state.ui.LOBTeam.flag = true;
      const findIndex = state.LOBTeam.findIndex((item) => item.id === action.payload.id);
      if (!state.selected.LOBTeam.includes(state.LOBTeam[findIndex])) {
        state.selected.LOBTeam[findIndex] = state.LOBTeam[findIndex];
      }
      state.LOBTeam.map((item) => {
        if (item) item.value = false;
      });
      state.selected.LOBTeam.map((item) => {
        if (item) item.value = false;
      });
      state.selected.LOBTeam[findIndex].value = action.payload.value;
      // state.LOBTeam[findIndex].value = action.payload.value;
    },

    handleAgentFilterChange: (state, action) => {
      const findIndex = state.LOBTeamAgent.findIndex((item) => item.id === action.payload.id);
      state.LOBTeamAgent.map((item) => {
        if (item) item.value = false;
      });
      state.selected.LOBTeamAgent.map((item) => {
        if (item) item.value = false;
      });

      if (!state.selected.LOBTeamAgent.includes(state.LOBTeamAgent[findIndex])) {
        state.selected.LOBTeamAgent[findIndex] = state.LOBTeamAgent[findIndex];
      }
      state.selected.LOBTeamAgent[findIndex].value = action.payload.value;
      // state.LOBTeamAgent[findIndex].value = action.payload.value;
    },
    setLobTeamDataByLob: (state, { payload }) => {
      console.log('actionpayloadCallflow', payload);
      state.LOBTeam = payload;
      state.LOBTeamAgent = [];
    },
    setLOBTeamAgentDataByLobTeam: (state, { payload }) => {
      state.LOBTeamAgent = payload;
    }
  },
  extraReducers: {
    [getCallCountData.pending]: (state) => {
      state.callCount.status = 'init';
      state.callCount.ui.loading = true;
    },

    [getCallCountData.fulfilled]: (state, action) => {
      state.callCount.status = 'idle';
      state.callCount.ui.loading = false;
      state.callCount.totalRecords = action.payload.total;
      const resData = action.payload.call_count;
      //getting resdata as object so converting it to array, as we need to pass array to common react-table
      const newData = Object.entries(resData)?.map(([key, value]) => {
        return { ...value, date: key };
      });
      state.callCount.data = newData;
    },

    [getCallCountData.rejected]: (state, action) => {
      state.callCount.status = 'error';
      state.callCount.error = action.error.message;
      state.callCount.ui.loading = false;
    },

    [getCallStatusData.pending]: (state) => {
      state.callStatus.status = 'init';
      state.callStatus.ui.loading = true;
    },

    [getCallStatusData.fulfilled]: (state, action) => {
      state.callStatus.status = 'idle';
      state.callStatus.ui.loading = false;
      state.callStatus.totalRecords = action.payload.total;
      const resData = action.payload.call_status;
      //getting resdata as object so converting it to array, as we need to pass array to common react-table
      const newData = Object.entries(resData)?.map(([key, value]) => {
        return { ...value, call_id: key };
      });
      state.callStatus.data = newData;
    },

    [getCallStatusData.rejected]: (state, action) => {
      state.callStatus.status = 'error';
      state.callStatus.error = action.error.message;
      state.callStatus.ui.loading = false;
    },

    [getErrorCallMessageData.pending]: (state) => {
      state.callStatus.status = 'init';
      state.callStatus.ui.loading = true;
    },

    [getErrorCallMessageData.fulfilled]: (state, action) => {
      state.callStatus.status = 'idle';
      state.callStatus.ui.loading = false;
      state.callStatus.errorData = action.payload;
    },

    [getErrorCallMessageData.rejected]: (state, action) => {
      state.callStatus.status = 'error';
      state.callStatus.error = action.error.message;
      state.callStatus.ui.loading = false;
    },

    [reRunCall.pending]: (state) => {
      state.callStatus.status = 'init';
      state.callStatus.ui.loading = true;
    },

    [reRunCall.fulfilled]: (state) => {
      state.callStatus.status = 'idle';
      state.callStatus.ui.loading = false;
    },

    [reRunCall.rejected]: (state, action) => {
      state.callStatus.status = 'error';
      state.callStatus.error = action.error.message;
      state.callStatus.ui.loading = false;
    },
    [getLobData.pending]: (state) => {
      state.callStatus.ui.loading = true;
    },

    [getLobData.fulfilled]: (state, action) => {
      console.log(action.payload, 'LOBCALLFLOW');
      state.LOB = action.payload;
      state.callStatus.ui.loading = false;
    },

    [getLobData.rejected]: (state, action) => {
      state.callStatus.error = action.error.message;
      state.callStatus.ui.loading = false;
    },
    [getteamData.pending]: (state) => {
      state.callStatus.ui.loading = true;
    },

    [getteamData.fulfilled]: (state, action) => {
      // state.LOB = !state.LOB ? state?.select_team?.value : [];
      state.LOBTeam = !state.LOB ? action?.payload : [];
      state.LOBTeam2 = action?.payload;
      state.callStatus.ui.loading = false;
    },

    [getteamData.rejected]: (state, action) => {
      state.callStatus.error = action.error.message;
      state.callStatus.ui.loading = false;
    },
    [getagentData.pending]: (state) => {
      state.callStatus.ui.loading = true;
    },

    [getagentData.fulfilled]: (state, action) => {
      state.LOBTeamAgent = !state.LOB && !state.LOBTeam ? action?.payload : [];
      state.LOBTeamAgent2 = action?.payload;
      state.callStatus.ui.loading = false;
    },

    [getagentData.rejected]: (state, action) => {
      state.callStatus.error = action.error.message;
      state.callStatus.ui.loading = false;
    },
    [ModalDataSubmit.pending]: (state) => {
      state.callStatus.ui.loading = true;
    },

    [ModalDataSubmit.fulfilled]: (state, action) => {
      state.modalData = action?.payload;
      state.callFlowModalValue = [];
      state.callStatus.ui.loading = false;
    },

    [ModalDataSubmit.rejected]: (state, action) => {
      state.callStatus.error = action.error.message;
      state.callStatus.ui.loading = false;
    },

    [resumeCall.pending]: (state) => {
      state.callStatus.status = 'init';
      state.callStatus.ui.loading = true;
    },

    [resumeCall.fulfilled]: (state) => {
      state.callStatus.status = 'idle';
      state.callStatus.ui.loading = false;
    },

    [resumeCall.rejected]: (state, action) => {
      state.callStatus.status = 'error';
      state.callStatus.error = action.error.message;
      state.callStatus.ui.loading = false;
    },

    [reRunFeatures.pending]: (state) => {
      state.callStatus.status = 'init';
      state.callStatus.ui.loading = true;
    },

    [reRunFeatures.fulfilled]: (state) => {
      state.callStatus.status = 'idle';
      state.callStatus.ui.loading = false;
    },

    [reRunFeatures.rejected]: (state, action) => {
      state.callStatus.status = 'error';
      state.callStatus.error = action.error.message;
      state.callStatus.ui.loading = false;
    }
  }
});

export const {
  setCurrentPage,
  setPageSize,
  setSelectedCallDate,
  setSelectedCallId,
  RemoveValueModal,
  setSelectedCallType,
  setCallCountData,
  setCallStatusData,
  setValueModal,
  handleLobFilterChange,
  handleTeamFilterChange,
  handleAgentFilterChange,
  setLobTeamDataByLob,
  setLOBTeamAgentDataByLobTeam
} = CallFlow.actions;

export default CallFlow.reducer;

export {
  getCallCountData,
  getCallStatusData,
  getErrorCallMessageData,
  reRunCall,
  getLobData,
  getteamData,
  getagentData,
  ModalDataSubmit,
  resumeCall,
  reRunFeatures
};
